<template>
  <header class="sm-header reg">
      <div class="sm-header-inner">
        <a 
          :href="provider.website_url || '/'" 
          class="sm-header__logo"
          target="_blank"
          rel="noreferrer"
        >
          <img-loader :src="headerLogoUrl" />
        </a>
        <div class="sm-header__reg">
          <div
            v-if="viewPort != 'large'"
            class="sm-header__reg-support"
          >
            <span>Have a question? </span>
            <a :href="`mailto:${provider.email}`">Ask support</a>
          </div>
          <button 
            v-if="isAdmin"
            class="sm-header__reg-admin"
            @click="switchToAdmin"
          >
            <include-svg :name="'icon-back'" />
            <span>Switch back</span>
          </button>
          <a
            href="#"
            class="sm-header__reg-logout"
            @click.prevent="logOut"
          >
            <include-svg 
              :name="!isLoggedIn ? 'icon-login' : 'icon-logout'" 
            />
            <span>{{!isLoggedIn ? 'Sign In' : 'Sign Out'}}</span>
          </a>
        </div>
      </div>
    </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Urls from '@/settings/urls';
import imageStore from '@/utils/image-store';
import ImgLoader from '@/components/ImgLoader';
import ViewPort from '@/mixins/ViewPort';

export default {
  name: 'header-reg-elem',
  components: {
    'img-loader': ImgLoader
  },
  data() {
    return {
      headerLogoUrl: '',
      allowedBreakpoints: [
        'large',
        'extraLarge'
      ]
    }
  },
  created() {
    this.getProvider()
      .then(res => {
        this.headerLogoUrl = imageStore(this.provider.image_url);
      });
  },
  computed: {
    ...mapGetters({
      provider: 'provider',
      user: 'auth/user',
      isAdmin: 'isAdmin'
    }),
    isLoggedIn() {
      return !!Object.keys(this.user).length;
    }
  },
  mixins: [ViewPort],
  methods: {
    ...mapActions({
      getProvider: 'getProvider',
      setIsAdmin: 'setIsAdmin',
    }),
    logOut() {
      // this.$router.push('/login');
      const wlp = window.location.port;
      const port = wlp === '8080' || wlp === '8081' ? ':' + wlp : ''; 
      const http = !port ? 'https' : 'http';
      const origin = window.location.hostname + port;
      window.location = Urls.logout + `?return_to=${http}://${origin}/customers/login`
    },
    switchToAdmin() {
      let adminAccess = localStorage.getItem('admin-access');

      if (adminAccess) {
        let adminAccessObj = JSON.parse(atob(adminAccess));
        this.setIsAdmin(false);
        localStorage.removeItem('admin-access');
        this.$router.push(`/admin/customers?access_token=${adminAccessObj.token}&refresh_token=${adminAccessObj.refresh_token}`);
      } else {
        window.location.href = `${window.location.origin}?classic=true`;
      }
    },
  }
}
</script>
